<template>
  <div>
    <hr>
    <grid
      ref="grid"
      @onPath="handlerPatch"
      @editor-custom-behaviour="handlerEditorCustomBehaviour"
      :config="gridConfig"
      class="no-grid-border"/>
  </div>
</template>

<script>
import gridConfig from './GridConfig'

export default {
  name: 'SupplierQuotesRFQ2MoreQuotesIndex',
  components: {
    'grid': () => import(/* webpackChunkName: 'Grid' */ '@/components/Grid/Index')
  },
  props: {
    data: { type: Object },
    listSelectedQuotes: { type: Array }
  },
  created () {
    this.$bus.$on('update-supplier-more-quotes', this.handlerUpdateGrid)
  },
  beforeDestroy () {
    this.$bus.$off('update-supplier-more-quotes', this.handlerUpdateGrid)
  },
  watch: {
    'data': {
      immediate: true,
      handler: 'setGridFilter'
    },
    'listSelectedQuotes': 'updateViewChosen'
  },
  data () {
    let gridConfigMix = {
      store: {
        get: {
          parser: this.parserGridData
        }
      }
    }
    let gridConfigWithParser = this.$_.merge(gridConfig, gridConfigMix)
    return {
      gridConfig: gridConfigWithParser
    }
  },
  computed: {
    mapSelectedQuotes () {
      return this.listSelectedQuotes.reduce((result, item) => {
        result[item.id] = result
        return result
      }, {})
    }
  },
  methods: {
    parserGridData (data) {
      let newData = data.map((dataItem) => {
        let isChosen = !!this.mapSelectedQuotes[dataItem.id]
        return {
          ...dataItem,
          'custom_chosen': isChosen
        }
      })
      this.$emit('update:listSelectedQuotes', newData.filter((item) => item['custom_chosen']))
      return newData
    },
    updateViewChosen () {
      let grid = this.getGrid()
      grid.data.forEach((row) => {
        row['custom_chosen'] = !!this.mapSelectedQuotes[row.id]
      })
    },
    handlerEditorCustomBehaviour (row, editor, data, callback) {
      let isOldItem = !!this.mapSelectedQuotes[row.id]
      let newListSelectedQuotes = []
      if (isOldItem) {
        newListSelectedQuotes = this.listSelectedQuotes.filter(quote => row.id !== quote.id)
      } else {
        newListSelectedQuotes = this.listSelectedQuotes.concat([ row ])
      }
      this.$emit('update:listSelectedQuotes', newListSelectedQuotes)
      callback()
    },
    handlerPatch () {
      this.$bus.$emit('update-supplier-more-quotes', this.getGrid())
    },
    handlerUpdateGrid (grid) {
      let componentGrid = this.getGrid() // current grid
      if (grid !== componentGrid) { //  // Trigger from anotherGrid
        componentGrid.loadData()
      }
    },
    getGrid () {
      return this.$refs['grid']
    },
    setGridFilter (data) {
      if (!Object.keys(data).length) {
        return
      }
      let grid = this.getGrid()
      let { supplierCompanyID, rfqid } = data
      let filters = `( rfqid != "${rfqid}" && supplierCompanyID == ${supplierCompanyID} && chosen == false)`
      if (grid) {
        grid.model.store.get.filters = filters
        grid.loadData()
      } else {
        this.gridConfig.store.get.filters = filters
      }
    }
  }
}
</script>
